module.exports = __webpack_public_path__ + "static/media/download.71389802.svg";